import React, { useState } from "react";
import CheckoutItem from "../../Components/CheckoutItem/CheckoutItem";
import "./CheckoutPage.scss";
import Button from "../../Components/Button/Button";
import { CircularProgress } from "@material-ui/core";
import { useSelector } from "react-redux";
import { RemoveShoppingCartSharp } from "@material-ui/icons";

const CheckoutPage = ({ history }) => {
  const [showLoading, setShowloading] = useState(false);
  const cart = useSelector((state) => state.cart.cart);

  const getTotal = () => {
    let total = 0;

    for (let i = 0; i < cart.length; i++) {
      total = total + cart[i].total * cart[i].quantity;
    }

    return total;
  };

  return (
    <div className="CheckoutPage">
      <h1>Checkout</h1>

      {cart.length ? (
        <div className="checkout-content">
          <div className="header">
            <p>Product</p>
            <p>Name</p>
            <p>Quantity</p>
            <p>Price</p>
            <p>Remove</p>
          </div>
          <div className="items">
            {cart.map((item) => (
              <CheckoutItem data={item} />
            ))}
          </div>

          <div className="footer">
            <Button
              text="Confirm Order"
              onClick={() => history.push("/confirm-order")}
            />
            <p>TOTAL : &pound;{getTotal()}</p>
          </div>
        </div>
      ) : (
        <div className="empty">
          <RemoveShoppingCartSharp style={{ fontSize: 150, color: "43444d" }} />
          <h1>Cart is Empty</h1>
        </div>
      )}
    </div>
  );
};

export default CheckoutPage;
